var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataConnection = function SvgDataConnection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "m15.502 8.066-5.963 3.155a3.6 3.6 0 0 1 .063 1.183l5.955 3.466a3.393 3.393 0 1 1-.842 2.258l-6.158-3.584a3.563 3.563 0 1 1-.286-5.338l6.445-3.41a3.393 3.393 0 1 1 .786 2.27"
  })));
};
export default SvgDataConnection;